import React from 'react';
import './App.css';
import screen from './img/screen.jpg';

const App = () => {
  return (
    <div className="container">
     <div className="navbar">
       <h2 className="logo">ShareNotes</h2>
       <a href="https://drive.google.com/uc?export=download&id=1nt1VbB8NOaxpvOc5Y1keuIaQQ6vSep5f" className="download">
         Download 
       </a>
     </div>
     <div className="intro">
       <div className="introtext">
         <h2>Welcome to ShareNotes</h2>
         <p>A realtime note-sharing app for College</p> <br />
         <a href="https://drive.google.com/uc?export=download&id=1nt1VbB8NOaxpvOc5Y1keuIaQQ6vSep5f" className="mdownload">Download</a>
       </div>
       <div className="screen">
         <img className="screenshot" src={screen} />
       </div>
     </div>
     <div className="more">
     <div className="stack">
         <h3>Tech Stack</h3>
         <p>Technologies used to build ShareNotes</p>
         <div className="stackimages">
           <img className="icon" src="https://www.vectorlogo.zone/logos/reactjs/reactjs-icon.svg" />
           <img className="icon" src="https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg" />
           <img className="icon" src="https://www.vectorlogo.zone/logos/git-scm/git-scm-icon.svg" />
           <img className="icon" src="https://www.vectorlogo.zone/logos/figma/figma-icon.svg" />
         </div>
       </div>
       <div className="source">
       <h3>Open Source</h3>
         <p>Download the source code right away!</p> 
         <br />
         <a href="https://github.com/ArunGovil/ShareNotesApp" className="sdownload">View Source</a>
         <br />
       </div>
     </div>
     <div className="footer">
       <div className="qlinks">
        <h3>Quick Links</h3>
         <a href="#" className="link">About Us</a>
         <a href="#" className="link">Contribute</a>
         <a href="#" className="link">Contact Us</a>
       </div>
       <div className="endlogo">
         <h2>ShareNotes.</h2>
       </div>
     </div>
     <div className="bottom">
       <p className="bottomline">
         Maintained by <a className="mention" href="https://twitter.com/be_like_arun">ShareNotes</a>
       </p>
       </div>
    </div>
  );
};

export default App;